<script>
import axios from "axios";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { required, email } from "vuelidate/lib/validators";
let user = JSON.parse(localStorage.getItem("user"));

export default {
  page: {
    title: "Thêm tài khoản nhân viên",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Thêm nhân viên",
      items: [
        {
          text: "Trang Chủ",
          href: "/",
        },
        {
          text: "Thêm nhân viên",
          active: true,
        },
      ],

      user: {
        team: null,
        username: null,
        email: null,
        password: null,
        price: null,
        viewPrice: true,
        ip: null,
        domain: null,
      },
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,
      scriptSuccess: null,
    };
  },
  validations: {
    user: {
      username: { required },
      email: { required, email },
      password: { required },
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    tryToRegisterIn() {
      this.submitted = true;
      const self = this;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      // ✅ reset trạng thái trước khi gửi
      this.isRegisterError = false;
      this.regError = null;
      this.registerSuccess = false;
      this.scriptSuccess = null;

      axios({
        url: process.env.VUE_APP_SERVER_URL + "/api/user/add",
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: {
          username: this.user.username,
          email: this.user.email,
          password: this.user.password,
        },
      })
        .then(({ data }) => {
          this.tryingToRegister = false;
          this.isRegisterError = false;
          this.registerSuccess = true;
          this.$toasted.success("Thêm tài khoản thành công");

          if (data.script) {
            this.scriptSuccess = data.script;
            setTimeout(function () {
              if (data.PinalaDomain && data.PinalaDomain.domain) {
                self.user.domain = data.PinalaDomain.domain;
              }
              window.scrollTo(0, 0);
            }, 500);
          } else {
            this.scriptSuccess = null;
          }

          return data;
        })
        .catch((error) => {
          this.tryingToRegister = false;

          // ✅ chuẩn hóa message lỗi
          let msg = "Đã xảy ra lỗi không xác định.";
          if (error && error.response) {
            const res = error.response;
            if (
              res.status === 422 &&
              res.data &&
              Array.isArray(res.data.errors) &&
              res.data.errors.length
            ) {
              msg = res.data.errors[0].msg || msg;
            } else if (typeof res.data === "string") {
              msg = res.data;
            } else if (res.data && res.data.message) {
              msg = res.data.message;
            }
          } else {
            msg = "Không thể kết nối đến máy chủ.";
          }

          // ✅ hiển thị lỗi gọn gàng
          this.regError = msg;
          this.isRegisterError = true;
          this.registerSuccess = false;
          this.scriptSuccess = null;

          // ✅ toast đẹp nếu có
          if (this.$toasted && typeof this.$toasted.error === "function") {
            this.$toasted.error(msg);
          }
        });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row justify-content-center">
      <div class="col-md-12 col-lg-8 col-xl-8">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Thêm tài khoản nhân viên mới</h5>
                  <p>Bạn cần nhập đầy đủ thông tin theo biểu mẫu.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>

          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.svg" alt class="rounded-circle" height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <div class="p-2">
              <!-- Hiển thị script -->
              <b-alert v-if="scriptSuccess" show variant="success" class="mt-0 mb-3">
                <b>Script đã tạo:</b>
                <pre class="mb-0">{{ scriptSuccess }}</pre>
              </b-alert>

              <!-- Hiển thị lỗi -->
              <b-alert v-model="isRegisterError" class="mt-3" variant="danger" dismissible>
                {{ regError }}
              </b-alert>

              <b-form class="p-2" @submit.prevent="tryToRegisterIn">
                <b-form-group class="mb-3" id="email-username" label="Tên hiển thị" label-for="username">
                  <b-form-input id="username" v-model="user.username" type="text" placeholder="Nhập tên hiển thị"
                    :class="{
                      'is-invalid': submitted && $v.user.username.$error,
                    }"></b-form-input>
                  <div v-if="submitted && $v.user.username.$error" class="invalid-feedback">
                    <span v-if="!$v.user.username.required">Vui lòng nhập tên hiển thị</span>
                  </div>
                </b-form-group>

                <b-form-group class="mb-3" id="email-group" label="Email" label-for="email">
                  <b-form-input id="email" v-model="user.email" type="email" placeholder="Nhập email" :class="{
                    'is-invalid': submitted && $v.user.email.$error,
                  }"></b-form-input>
                  <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                    <span v-if="!$v.user.email.required">Vui lòng nhập email</span>
                    <span v-if="!$v.user.email.email">Email chưa đúng định dạng</span>
                  </div>
                </b-form-group>

                <b-form-group class="mb-3" id="password-group" label="Mật khẩu" label-for="password">
                  <b-form-input id="password" v-model="user.password" type="password"
                    placeholder="Mật khẩu ít nhất 6 ký tự" :class="{
                      'is-invalid': submitted && $v.user.password.$error,
                    }"></b-form-input>
                  <div v-if="submitted && $v.user.password.$error" class="invalid-feedback">
                    <span v-if="!$v.user.password.required">Vui lòng nhập mật khẩu</span>
                  </div>
                </b-form-group>

                <div class="mt-4 d-grid gap-2">
                  <b-button type="submit" variant="primary" class="btn-block">
                    Thêm tài khoản
                  </b-button>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.bg-soft {
  background-color: rgba(85, 110, 230, 0.25);
}

.avatar-title {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  width: 80px;
  font-size: 2rem;
}

pre {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 14px;
  padding: 10px;
  background: #f7f7f7;
  border-radius: 5px;
}
</style>
